import React, { useRef, useEffect } from "react";
import { useFormikContext } from "formik";
import {
  scrollIntoFormContainer,
  findFirstCreateTicketErrorTarget,
  fallbackScrollToFirstValidationMessage,
} from "../utils/functions";

const ScrollToFirstError = ({
  containerRef,
  orderedCustomFieldKeys,
}: {
  containerRef: React.RefObject<HTMLDivElement | null>;
  orderedCustomFieldKeys: string[];
}) => {
  const { submitCount, errors, isSubmitting } = useFormikContext();
  const lastHandled = useRef(0);

  useEffect(() => {
    if (submitCount <= lastHandled.current || isSubmitting) return;

    const errObj = errors as Record<string, unknown>;
    if (Object.keys(errObj).length === 0) return;
    lastHandled.current = submitCount;

    const run = () => {
      const container = containerRef.current;
      if (!container) return;

      const target = findFirstCreateTicketErrorTarget(
        container,
        errObj,
        orderedCustomFieldKeys
      );
      if (target) {
        scrollIntoFormContainer(container, target);
        return;
      }
      fallbackScrollToFirstValidationMessage(container);
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        setTimeout(run, 50);
      });
    });
  }, [submitCount, errors, isSubmitting, containerRef, orderedCustomFieldKeys]);

  return null;
};

export default ScrollToFirstError;
